import React, { useState } from 'react';

export default function ShareByEmailModal({ onClose, onSubmit }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!email.trim()) {
      return;
    }

    setIsLoading(true);
    
    try {
      await onSubmit(email);
      setSuccessMessage(`Thank You! Your build has been sent to ${email}`);
    } catch (error) {
      console.error('Failed to share by email:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (successMessage) {
    return (
      <>
        <div className="modal-header">
          <h2 className="modal-title">Share By Email</h2>
        </div>
        <div className="modal-body saveBuildModalBody">
          <p>{successMessage}</p>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">Share By Email</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <form onSubmit={handleSubmit}>
          <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            value={email}
            onChange={handleInputChange}
            required
          />
          <button 
            type="submit" 
            className="send-quote-button orange-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Share'}
          </button>
        </form>
      </div>
    </>
  );
}